import { useRef, useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, Overline } from "./primitives";

const KAJABI_ACTION = "https://www.creatingwealth.community/forms/2149697192/form_submissions";
const KAJABI_TOKEN = "wqb7zZNBOJsnSgMTZ9PhVt5drSru1Qhnm8hplIV8RMFKaykD9_p6uTMQ-6vdNvUr2kBDx2ek6oRZSStmL2tHsw";

export const Newsletter = () => {
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [firstName, setFirstName] = useState("");
  const pending = useRef(false);

  const finish = () => {
    if (pending.current) {
      pending.current = false;
      setSending(false);
      setSubmitted(true);
    }
  };

  const onSubmit = (e) => {
    const name = e.target.elements["form_submission[name]"].value.trim();
    setFirstName(name.split(" ")[0]);
    pending.current = true;
    setSending(true);
    setTimeout(finish, 2500);
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-[760px] px-6 text-center md:px-10">
        {submitted ? (
          <div data-testid="newsletter-thankyou">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-terracotta/10">
              <Check className="h-6 w-6 text-terracotta" strokeWidth={1.8} />
            </span>
            <h2 className="mt-8 font-display text-3xl font-medium leading-[1.05] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              {firstName ? `${firstName}, you're ` : "You're "}
              <span className="italic text-terracotta">in.</span>
            </h2>
            <p className="mx-auto mt-6 max-w-md font-display text-xl italic leading-snug text-ink md:text-2xl">
              Consider this the beginning of something.
            </p>
            <p className="mx-auto mt-4 max-w-md font-sans text-lg font-light leading-relaxed text-stonegray">
              Keep an eye on your inbox — the good stuff is on its way. If we ever land in spam, rescue us. We're worth
              it.
            </p>
          </div>
        ) : (
          <>
            <Reveal><Overline>Stay Close</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-display text-3xl font-medium leading-[1.05] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                Join the <span className="italic text-terracotta">newsletter.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mx-auto mt-5 max-w-md font-sans text-lg font-light leading-relaxed text-stonegray">
                Subscribe to get our latest content by email.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <form
                data-testid="newsletter-form"
                action={KAJABI_ACTION}
                method="post"
                acceptCharset="UTF-8"
                target="kajabi-newsletter-frame"
                onSubmit={onSubmit}
                className="mx-auto mt-10 flex max-w-xl flex-col gap-4 sm:flex-row"
              >
                <input type="hidden" name="authenticity_token" value={KAJABI_TOKEN} autoComplete="off" />
                <input
                  type="text"
                  name="form_submission[name]"
                  required
                  placeholder="Name"
                  data-testid="newsletter-name-input"
                  className="w-full border border-ink/15 bg-alabaster/60 px-5 py-4 font-sans text-base font-light text-ink placeholder:text-stonegray/60 focus:border-terracotta focus:outline-none"
                />
                <input
                  type="email"
                  name="form_submission[email]"
                  required
                  placeholder="Email"
                  data-testid="newsletter-email-input"
                  className="w-full border border-ink/15 bg-alabaster/60 px-5 py-4 font-sans text-base font-light text-ink placeholder:text-stonegray/60 focus:border-terracotta focus:outline-none"
                />
                <button
                  type="submit"
                  data-testid="newsletter-submit-btn"
                  disabled={sending}
                  className={`group inline-flex shrink-0 items-center justify-center gap-3 px-8 py-4 font-sans text-sm font-medium uppercase tracking-[0.14em] text-white transition-[transform,background-color] duration-300 ${
                    sending ? "cursor-wait bg-ink/60" : "bg-terracotta hover:-translate-y-0.5 hover:bg-ink"
                  }`}
                >
                  <span>{sending ? "Subscribing..." : "Subscribe"}</span>
                  {!sending && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" strokeWidth={1.6} />}
                </button>
              </form>
            </Reveal>
          </>
        )}
        <iframe name="kajabi-newsletter-frame" title="newsletter-submission" onLoad={finish} className="hidden" />
      </div>
    </section>
  );
};
